import React from 'react';
import { motion } from 'framer-motion';
import { Book, PenTool, Zap, ClipboardList, MapPin } from 'lucide-react';
export function TomosGrid() {
  const tomos = [{
    num: 1,
    title: 'La Anatomía del Vínculo Frío',
    desc: 'Qué es un vínculo frío, por qué engancha tanto y cómo detectar el patrón antes de caer otra vez en lo mismo.'
  }, {
    num: 2,
    title: 'Tu Venus Natal: El Mapa del Amor que Merecés',
    desc: 'Cómo amar, recibir y elegir según tu Venus. Por qué repetís ciertos vínculos y cómo cambiarlo desde la raíz.'
  }, {
    num: 3,
    title: 'El Espejo de Lilith: Tu Sombra Como Poder',
    desc: 'Tu deseo profundo, tu sombra magnética y lo que inconscientemente te lleva a repetir las mismas historias.'
  }, {
    num: 4,
    title: 'Apegos, Ansiedad y Disponibilidad Emocional',
    desc: 'Cómo detectar hombres evitativos, ansiosos o indisponibles antes de engancharte de más y que te lastimen.'
  }, {
    num: 5,
    title: 'Regulación Emocional y Sistema Nervioso',
    desc: 'Qué hacer con la obsesión mental, la ansiedad y el impulso de escribirle cuando desaparece sin aviso.'
  }, {
    num: 6,
    title: 'Casa VII, Sinastría y Patrones de Pareja',
    desc: 'Cómo leer tu carta natal para entender por qué atraés lo que atraés y qué energía vincular necesitás sanar.'
  }, {
    num: 7,
    title: 'El Fin de las Migajas',
    desc: 'Límites reales, estándar propio y cómo dejar de aceptar vínculos ambiguos que te desgastan sin darte nada.'
  }, {
    num: 8,
    title: 'Programación Subconsciente',
    desc: 'Cómo reprogramar los patrones internos que te hacen elegir desde la herida y no desde tu valor real.'
  }, {
    num: 9,
    title: 'Lectura de Energía en la Primera Cita',
    desc: 'Cómo detectar red flags energéticas, disponibilidad real y coherencia antes de que te enganches emocionalmente.'
  }, {
    num: 10,
    title: 'Corte de Lazos y Cierre Energético',
    desc: 'Cómo soltar a un ex, romper la fijación emocional y limpiar tu campo de vínculos viejos que siguen drenándote.'
  }, {
    num: 11,
    title: 'Magnetismo, Presencia y Autoestima Encarnada',
    desc: 'Cómo dejar de sentirte invisible y convertirte en una mujer que se siente, se nota y se elige primero a sí misma.'
  }, {
    num: 12,
    title: 'Tu Nuevo Código de Amor',
    desc: 'Integración final y nuevo estándar vincular para que no vuelvas atrás nunca más.'
  }];
  return <section className="py-20 px-4 bg-mystic-900 relative" data-id="element-279">
      <div className="max-w-6xl mx-auto" data-id="element-280">
        <div className="text-center mb-16" data-id="element-281">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-282">
            Los 12 Tomos Completos
          </h2>
          <p className="text-xl text-lilac-300 font-medium" data-id="element-283">
            Por dolor · Por patrón · Listo para aplicar hoy mismo
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-284">
          {tomos.map((tomo, i) => <motion.div key={tomo.num} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i % 3 * 0.1
        }} className="bg-mystic-800/40 border border-mystic-700 hover:border-lilac-500/50 transition-colors rounded-2xl p-6 flex flex-col h-full" data-id="element-285">
              <div className="text-gold-400 font-bold text-sm tracking-widest uppercase mb-3" data-id="element-286">
                TOMO {tomo.num}
              </div>
              <h3 className="text-xl font-serif font-bold text-white mb-3 leading-tight" data-id="element-287">
                {tomo.title}
              </h3>
              <p className="text-slate-300 text-sm flex-grow leading-relaxed" data-id="element-288">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm md:text-base text-slate-200 bg-mystic-800/30 py-6 px-4 rounded-2xl border border-mystic-700/50" data-id="element-289">
          <div className="flex items-center gap-2" data-id="element-290">
            <PenTool className="w-5 h-5 text-lilac-400" data-id="element-291" />
            <span data-id="element-292">✏️ Ejercicios aplicados en cada tomo</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-293">
            <Zap className="w-5 h-5 text-gold-400" data-id="element-294" />
            <span data-id="element-295">⚡ Sistema "Abrís y Aplicás"</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-296">
            <ClipboardList className="w-5 h-5 text-lilac-400" data-id="element-297" />
            <span data-id="element-298">
              📋 Protocolos, tests, journaling y rituales listos para usar
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-299">
            <MapPin className="w-5 h-5 text-gold-400" data-id="element-300" />
            <span data-id="element-301">🇦🇷 Contenido adaptado al lenguaje y realidad argentina</span>
          </div>
        </div>
      </div>
    </section>;
}